/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LpInspectionCouponDto } from '../../models/lp-inspection-coupon-dto';
import { UpdateLpInspectionCouponDto } from '../../models/update-lp-inspection-coupon-dto';

export interface LpInspectionCouponControllerUpdate$Params {
  id: string;

/**
 * 아동 ID (선택적)
 */
  childId?: string;
      body: UpdateLpInspectionCouponDto
}

export function lpInspectionCouponControllerUpdate(http: HttpClient, rootUrl: string, params: LpInspectionCouponControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<LpInspectionCouponDto>> {
  const rb = new RequestBuilder(rootUrl, lpInspectionCouponControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('childId', params.childId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LpInspectionCouponDto>;
    })
  );
}

lpInspectionCouponControllerUpdate.PATH = '/api/lp-inspection-coupon/{id}';
